import React, { useCallback } from "react";

import { DeviceTesterTestState } from "../../../types/Device.types";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import { useDeviceTesterDispatchContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { logFinishedSessionAfterAudioTest } from "../audio-test-ended-issue/ConnectedAudioTestEndedIssue.telemetry";

import { AudioTestEndedWorking } from "./AudioTestEndedWorking";
export const ConnectedAudioTestEndedWorking: React.FC = () => {
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  // Callback to run test again
  const runTestAgain = useCallback(async () => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.RESULTS,
    });
  }, [deviceTesterDispatch]);

  // Callback to move to final test completed page
  const testCompleted = useCallback(async () => {
    logFinishedSessionAfterAudioTest();
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.COMPLETE,
    });
  }, [deviceTesterDispatch]);

  return (
    <AudioTestEndedWorking
      completeTest={testCompleted}
      runTestAgain={runTestAgain}
    />
  );
};
